module.exports = __webpack_public_path__ + "img/title_1@2x.cc252a46.svg";